import { z } from "zod/v4";

import { castToCommaList, castToNumber, validateIdNotExponent } from "../utils";

export const TestProductInputStateList = ["price", "compareAtPrice"] as const;
export type TestProductInputStateType =
  (typeof TestProductInputStateList)[number];

export const FileBuildTestGroupStateSchema = z.object({
  name: z.string(),
  percentage: z.number(),
  order: z.number(),
});
export type FileBuildTestGroupStateType = z.infer<
  typeof FileBuildTestGroupStateSchema
>;

// Test Groups within Variants
export const ProductVariantEventStatusList = [
  "pending",
  "failed",
  "successful",
] as const;
export type ProductVariantEventStatus =
  | (typeof ProductVariantEventStatusList)[number]
  | null
  | undefined;

export const BuildFileTypesList = ["csv", "excel"] as const;
export type BuildFileTypes = (typeof BuildFileTypesList)[number];

export const CogsExcelUploadSchema = z.object({
  productId: validateIdNotExponent,
  variantId: validateIdNotExponent,
  cogs: castToNumber,
  shopifyDomain: z.string().nullish().default(""),
  updatedAtTs: z.coerce.number().nullish().default(0),
  productGroup: z.string().nullish().default(""),
});
export type CogsExcelUploadRow = z.infer<typeof CogsExcelUploadSchema>;

export const CogsExcelDownloadSchema = CogsExcelUploadSchema.extend({
  productTitle: z.string().nullish().default(""),
  variantTitle: z.string().nullish().default(""),
  sku: z.string().nullish().default(""),
  handle: z.string().nullish().default(""),
  inventory: z.coerce.number().nullish().default(0),
  tags: castToCommaList.nullish().default(""),
  productType: z.string().nullish().default(""),
  status: z.string().nullish().default(""), // z.enum(["ACTIVE", "DRAFT", "ARCHIVED"]),
  price: castToNumber,
  compareAtPrice: castToNumber.nullish(),
});
export type CogsExcelDownloadRow = z.infer<typeof CogsExcelDownloadSchema>;
